import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import CustomerForm from "./componenets/Customer";
import OrderItems from "./componenets/OrderItems";
import {
  CANCELLED_ORDER_REQUEST,
  GET_ALL_RESTAURANT_CATEGORY_LIST_REQUEST,
  GET_ALL_RESTAURANT_SUB_CATEGORY_LIST_REQUEST,
  GET_ORDER_LIST_REQUEST,
  GET_ROOM_LIST_REQUEST,
  GET_TABLE_LIST_REQUEST,
  POST_ORDER_LIST_REQUEST,
  PUT_ORDER_LIST_REQUEST,
} from "../../../../Utils/Constant";
import FormSelect from "../../../../Lib/FormSelect";
import FormInput from "../../../../Lib/FormInput";
import ConfirmationATM from "../../../../Common/ConfirmationATM";
import { getBaseUrl } from "../../../../Redux/Config/AppConfig";
import { hasEditAccess } from "../../../../Common/CheckAccess";
import { toast } from "react-toastify";
import { isEqual } from "lodash";
import { useHotel } from "../../../../Common/HotelContext";

const getInitialState = () => ({
  table_id: "",
  room_id: "",
  guests: [
    {
      name: "",
      email: "",
      phone: "",
    },
  ],
  order_items: [],
  service_charge: 0,
  tax: 5,
  discount: 0,
  tip: 0,
  comment: "",
  status: "pending",
  unit_price: "",
  variant_price: "",
  date_time: "",
  guest_type: "restaurant_guest",
  order_type: "table_booking",
});

const CreateOrder = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const hotel_id = localStorage.getItem("hotel_id");
  console.log(id, "id");
  const queryParams = new URLSearchParams(location.search);
  const baseUrl = getBaseUrl();
  const isViewOnly = queryParams.get("isViewOnly") === "true";
  const { orderList, addSuccess } = useSelector((state) => state.order);

  const [formData, setFormData] = useState(getInitialState());
  const [isLoading, setIsLoading] = useState(false);
  const { tablesList = [] } = useSelector((state) => state.table);
  const [isEditable, setIsEditable] = useState(() => !id && !isViewOnly);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [roomOptions, setRoomOptions] = useState([]);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("cash");
  const [isPaymentLoading, setIsPaymentLoading] = useState(false);
  const {
    categoryList = [],
    subCategoryList = [],
    varientList = [],
  } = useSelector((state) => state.restaurant);
  const { roomList } = useSelector((state) => state.roomType);
  const [is_room, setIsRoom] = useState(false);
  const [permissions, setPermissions] = useState([]);

  const existingPermissions = localStorage.getItem("checkPermission");

  useEffect(() => {
    if (existingPermissions != undefined) {
      const parsedData = JSON.parse(existingPermissions);
      setPermissions(parsedData);
    }
  }, [existingPermissions]);

  const [selectedVariants, setSelectedVariants] = useState({});

  const categoryOptions = useMemo(() => {
    return (
      categoryList?.data?.categories?.map((category) => ({
        label: category.name,
        value: category.id,
      })) || []
    );
  }, [categoryList]);

  const tables = useMemo(() => {
    if (!tablesList?.data?.data) return [];

    const selectedTable = tablesList?.data?.data.find(
      (table) => table.id === formData.table_id
    );

    const availableTables = tablesList?.data?.data
      .filter((table) => table.status === "available")
      .map((table) => ({
        value: table.id,
        label: table.name,
      }));

    if (
      selectedTable &&
      formData.table_id &&
      !availableTables.some((table) => table.value === formData.table_id)
    ) {
      return [
        {
          value: selectedTable.id,
          label: `${selectedTable.name}`,
        },
        ...availableTables,
      ];
    }

    return availableTables;
  }, [tablesList, formData.table_id]);

  const [initialFormData, setInitialFormData] = useState(getInitialState());
  const [isDirty, setIsDirty] = useState(false);

  const { selectedHotel } = useHotel();

  useEffect(() => {
    if(!id){
    async function getSetting() {
      try {
        const token = localStorage.getItem("token");
        const res = await fetch(
          `${baseUrl}/restaurant-settings?hotel_id=${selectedHotel}`,
          {
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        const data = await res.json();
        if (data.data) {
          setFormData({
            ...formData,
            service_charge:data.data.restaurant_service_charge || 10,
            tax: data.data.restaurant_tax || 5,
            discount: data.data.restaurant_discount || 0,
          })
         
        }
        // if (res.ok) {
        //   toast.success("Settings saved successfully!");
        // } else {
        //   toast.error("Failed to save settings");
        // }
      } catch (err) {
        toast.error("Failed to save settings");
      }
    }
    getSetting();
  }
  }, []);

  useEffect(() => {
    if (id && orderList && orderList.data?.length > 0) {
      // const order = orderList.data[0];
      const order = orderList.data.find(item => item.id === id);
      console.log("order", order,"orderList",orderList);
      const loadedData = {
        table_id: order.table_id || "",
        guests: [
          {
            name: order?.guest_info?.name,
            email: order?.guest_info?.email || "",
            phone: order?.guest_info?.phone || "",
          },
        ],
        order_items:
          order.items?.map((item) => ({
            name: item.subcategory.name,
            item_id: item?.item_id,
            category_name: item?.subcategory.category.name,
            variant_name: item?.variant?.name,
            variant_id: item?.variant?.id,
            quantity: item?.quantity,
            variant_price: item.variant_price || 0,
            unit_price: item?.unit_price,
            total: item?.total_price,
            category_id: item?.variant?.category_id,
            subcategory_id: item?.subcategory?.id,
            comment: item?.comment || "",
          })) || [],
        service_charge: order.service_charge || 0,
        tax: order.tax || 5,
        discount: order?.discount || 0,
        tip: order?.tip || 0,
        comment: order?.comment || "",
        status: order?.status || "pending",
        unit_price: order?.unit_price || "",
        date_time: order?.booking?.booking_time || order?.booking_date|| "",
        guest_type: order?.guest_type || "",
        order_type: order?.order_type,
        room_id: order?.room?.id || "",
        room_number: order?.room?.room_number || "",
      };
      setFormData(loadedData);
      setInitialFormData(loadedData);
    }
  }, [orderList, id]);

  useEffect(() => {
    if (formData && initialFormData)
      setIsDirty(!isEqual(formData, initialFormData));
  }, [formData, initialFormData]);

  useEffect(() => {
    if (id) {
      dispatch({
        type: "GET_ORDER_BY_ID_REQUEST",
        payload: { id },
      });
    }
  }, [id, dispatch]);

  useEffect(() => {
    const payload = { page: 1, limit: 100 };
    if (formData?.date_time) {
      payload.datetime = formData?.date_time;
    }
    dispatch({ type: GET_TABLE_LIST_REQUEST, payload });
  }, [dispatch, formData?.date_time]);

  useEffect(() => {
    if (id) {
      dispatch({
        type: GET_ORDER_LIST_REQUEST,
        payload: { order_id: id },
      });
    }
  }, [id, dispatch]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isViewOnly) return;

    // --- Validation ---
    const errors = [];
    // Guest name required
    // if (!formData.guests[0]?.name?.trim()) {
    //   errors.push("Guest name is required.");
    // }
    // At least one order item
    if (!formData.order_items || formData.order_items.length === 0) {
      errors.push("Please add at least one item to the order.");
    }
    // Service charge, tax, discount: 0-100 or empty
    // const percentFields = [
    //   { key: "service_charge", label: "Service Charge" },
    //   { key: "tax", label: "Tax" },
    //   { key: "discount", label: "Discount" },
    // ];
    // percentFields.forEach(({ key, label }) => {
    //   const val = formData[key];
    //   if (val !== "" && (isNaN(val) || Number(val) < 0 || Number(val) > 100)) {
    //     errors.push(`${label} must be a number between 0 and 100.`);
    //   }
    // });
    // Tip: >= 0 or empty
    // if (formData.tip !== "" && (isNaN(formData.tip) || Number(formData.tip) < 0)) {
    //   errors.push("Tip must be a number greater than or equal to 0.");
    // }
    // Table/Room/Date required for respective order types
    if (formData.order_type === "table_booking") {
      if (!formData.table_id) errors.push("Table selection is required.");
      if (!formData.date_time) errors.push("Date/Time is required.");
    }
    if (formData.order_type === "room_service") {
      if (!formData.room_id) errors.push("Room selection is required.");
    }
    // Show first error as toast and prevent submit
    if (errors.length > 0) {
      toast.error(errors[0]);
      return;
    }
    setIsLoading(true);
    try {
      const payload = {
        name: formData.guests[0]?.name,
        email: formData.guests[0]?.email || "",
        phone: formData.guests[0]?.phone || "",
        comment: formData.comment,
        tip: Number.parseFloat(formData.tip) || 0,
        discount: Number.parseFloat(formData.discount) || 0,
        service_charge: Number.parseFloat(formData.service_charge) || 0,
        tax: Number.parseFloat(formData.tax) || 5,
        order_items: formData.order_items.map((item) => ({
          subcategory_id: item.subcategory_id,
          variant_id: item.variant_id,
          quantity: item.quantity,
          notes: item.comment || "",
        })),
        order_type: formData.order_type,
        guest_type: formData.guest_type,
        guest_id: formData?.guest_id,
      };
      console.log(formData)

      // Add table_id or room_id based on order_type
      if (formData.order_type === "table_booking") {
        payload.date_time = formData?.date_time;
        payload.table_id = formData.table_id;
        if (formData.guest_type === "hotel_guest" && formData?.room_id) {
          payload.room_number_id = formData.room_id;
        }
      } else if (
        formData.order_type === "room_service" ||
        (formData.guest_type === "hotel_guest" && formData?.room_id)
      ) {
        payload.room_number_id = formData.room_id;
      }

      const hotel_id = localStorage.getItem("hotel_id");

      if (id) {
        await dispatch({
          type: PUT_ORDER_LIST_REQUEST,
          payload: { id, data: { ...payload, hotel_id } },
        });
      } else {
        await dispatch({
          type: POST_ORDER_LIST_REQUEST,
          payload: { ...payload, hotel_id },
        });
      }
      dispatch({
        type: GET_ORDER_LIST_REQUEST,
        payload: { page: 1, limit: 10 },
      });
      setTimeout(() => {
        navigate("/restaurant/order");
      }, 500);
    } catch (error) {
      console.error("Order operation failed:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const updateGuestData = (guestIndex, updatedGuest, guest_id) => {
    const updatedGuests = [...formData.guests];
    updatedGuests[guestIndex] = updatedGuest;
    setIsRoom(false);
    setFormData((prev) => ({
      ...prev,
      guests: updatedGuests,
      guest_id: guest_id,
    }));
  };

  const removeGuest = (index) => {
    const updatedGuests = formData.guests.filter((_, i) => i !== index);
    setFormData((prev) => ({ ...prev, guests: updatedGuests }));
  };

  const calculateTotals = () => {
    const subtotal = formData.order_items.reduce(
      (sum, item) => sum + Number.parseFloat(item.total || 0),
      0
    );

    const serviceCharge = Number.parseFloat(formData.service_charge || 0);
    const tax = Number.parseFloat(formData.tax || 5);
    const discount = Number.parseFloat(formData.discount || 0);

    const serviceChargeAmount = (subtotal * serviceCharge) / 100;
    const taxAmount = ((subtotal + serviceChargeAmount) * tax) / 100;
    const discountAmount = (subtotal * discount) / 100;

    const tip = Number.parseFloat(formData.tip || 0);

    const total =
      subtotal + serviceChargeAmount + taxAmount - discountAmount + tip;

    return {
      subtotal,
      serviceChargeAmount,
      taxAmount,
      discountAmount,
      total,
      tip,
    };
  };

  let totals = calculateTotals();
  useEffect(() => {
    totals = calculateTotals();
  }, [formData]);

  const toDateTimeLocal = (isoString) => {
    if (!isoString) return "";
    const date = new Date(isoString);
    const offset = date.getTimezoneOffset();
    const local = new Date(date.getTime() - offset * 60000);
    return local.toISOString().slice(0, 16);
  };

  const handleDateChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      date_time: e.target.value || Date.now(),
    }));
  };

  const handleCancelClick = () => {
    setShowCancelModal(true);
  };

  const handleConfirmCancel = () => {
    setShowCancelModal(false);
    dispatch({
      type: CANCELLED_ORDER_REQUEST,
      payload: { id },
    });
    navigate("/restaurant/order");
  };

  const handleCloseCancelModal = () => {
    setShowCancelModal(false);
  };

  const [activeCategory, setActiveCategory] = useState(null);

  const handleCategorySelect = (category) => {
    setActiveCategory(category);
  };

  useEffect(() => {
    if (activeCategory === null && categoryOptions?.length > 0) {
      setActiveCategory(categoryOptions[0]);
    }
  }, [categoryOptions, activeCategory]);

  useEffect(() => {
    if (formData.date_time) {
      dispatch({ type: GET_ROOM_LIST_REQUEST, payload: { type: "in-house" } });
    }
  }, [dispatch, formData.date_time]);

  useEffect(() => {
    if (roomList?.data?.data?.rooms?.length > 0) {
      const options = roomList?.data?.data?.rooms?.map((itm) => ({
        label: itm.room_number,
        value: itm.id,
      }));
      setRoomOptions(options);
    }
  }, [roomList]);

  useEffect(() => {
    if (activeCategory?.value) {
      dispatch({
        type: GET_ALL_RESTAURANT_SUB_CATEGORY_LIST_REQUEST,
        payload: {
          body: { page: 1 },
          id: activeCategory.value,
        },
      });
    }
  }, [activeCategory, dispatch]);

  const filteredItems = subCategoryList?.data?.data || [];

  const handleVariantChange = (itemId, variantId) => {
    setSelectedVariants((prev) => ({
      ...prev,
      [itemId]: variantId,
    }));
  };

  const handleAddItem = (item) => {
    // For items with variants, use the selected variant if one is chosen
    // Otherwise, use null to indicate no variant is selected (regular item)
    const selectedVariantId = selectedVariants[item.id] || null;

    // Determine the variant to use (if any)
    let selectedVariant;
    if (selectedVariantId && item.variants && item.variants.length > 0) {
      selectedVariant = item.variants.find((v) => v.id === selectedVariantId);
    }

    // If no variant is selected or found, use a regular item representation
    if (!selectedVariant) {
      selectedVariant = { id: null, name: "", price: 0 };
    }

    // Check if item with same variant already exists in order
    const existingItemIndex = formData.order_items.findIndex(
      (orderItem) =>
        orderItem.item_id === item.id &&
        orderItem.variant_id === (selectedVariant.id || null)
    );

    if (existingItemIndex >= 0) {
      // If item exists, increment quantity
      const updatedItems = [...formData.order_items];
      updatedItems[existingItemIndex].quantity += 1;
      updatedItems[existingItemIndex].total =
        (parseFloat(updatedItems[existingItemIndex].unit_price) +
          parseFloat(updatedItems[existingItemIndex].variant_price || 0)) *
        updatedItems[existingItemIndex].quantity;

      setFormData((prev) => ({
        ...prev,
        order_items: updatedItems,
      }));
    } else {
      // If item doesn't exist, add new item
      const newOrderItem = {
        item_id: item.id,
        name: item.name,
        variant_name: selectedVariant.name,
        category_name: activeCategory?.label || "",
        subcategory_id: item?.id,
        variant_id: selectedVariant.id || null,
        quantity: 1,
        unit_price: Number.parseFloat(item.price),
        variant_price: Number.parseFloat(selectedVariant.price || 0),
        total:
          Number.parseFloat(selectedVariant.price || 0) +
          parseFloat(item.price),
        comment: "",
      };

      setFormData((prev) => ({
        ...prev,
        order_items: [...prev.order_items, newOrderItem],
      }));
    }
  };

  useEffect(() => {
    dispatch({ type: GET_ALL_RESTAURANT_CATEGORY_LIST_REQUEST });
  }, []);

  const handleGuestTypeChange = (type) => {
    setFormData((prev) => ({
      ...prev,
      guest_type: type,
    }));
  };

  const handleOrderTypeChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      order_type: e.target.value,
      guests: prev.guests[0].name
        ? prev.guests
        : [
            {
              name: "",
              email: "",
              phone: "",
            },
          ],
    }));
  };

  // Payment handling function
  const handlePayNow = async () => {
    if (formData.order_items.length === 0) {
      alert("Please add items to the order before completing payment.");
      return;
    }
    setShowPaymentModal(true);
  };

  // Payment handling function
  const handlePayAtCheckout = async () => {
    await processPayment("pay_at_checkout", "pay_at_checkout");
  };

  const processPayment = async (event, type) => {
    setIsPaymentLoading(true);
    try {
      const totals = calculateTotals();
      // Simplified payload with only required fields
      const paymentPayload = {
        order_id: id,
        method: paymentMethod,
        amount: totals.total,
        type: type || "pay_now",
        hotel_id,
      };
      let token = localStorage.getItem("token");
      const response = await fetch(`${baseUrl}/order-payment`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`, // ← Add your token here
        },
        body: JSON.stringify(paymentPayload),
      });
      if (response.status === 201) {
        setShowPaymentModal(false);
        // Close modal and navigate
        setTimeout(() => {
          navigate("/restaurant/order");
        }, 500);
      }
    } catch (error) {
      console.error("Payment processing failed:", error);
      alert("Payment processing failed. Please try again.");
    } finally {
      setIsPaymentLoading(false);
    }
  };

  useEffect(() => {
    setIsRoom(formData?.room_id ? true : false);
  }, [formData.room_id]);

  return (
    <div
      className="container-fluid p-0"
      style={{ marginTop: "0", paddingTop: "0" }}
    >
      <div className="row g-0" style={{ height: "calc(100vh - 110px)" }}>
        {/* Left Side - Menu Section (65%) */}
        <div
          className="col-8"
          style={{ maxWidth: "65%", flex: "0 0 65%", height: "100%" }}
        >
          <div className="h-100 overflow-auto bg-light">
            {/* Header */}
            <div className="text-center py-4 bg-white border-bottom">
              <h2 className="fw-bold mb-4">Our Menu</h2>

              {/* Category Filters */}
              <div className="d-flex justify-content-center gap-2 flex-wrap">
                {categoryOptions?.map((category) => (
                  <button
                    key={category?.label}
                    className={`btn ${
                      activeCategory?.label === category?.label
                        ? " bg-black text-white"
                        : "btn-outline-secondary"
                    } btn-sm px-3 py-2`}
                    onClick={() => {
                      handleCategorySelect(category);
                    }}
                  >
                    {category?.label}
                  </button>
                ))}
              </div>
            </div>

            {/* Menu Items */}
            <div className="p-3">
              <div className="row g-3">
                {filteredItems.map((item) => {
                  // Ensure item has a variants array, even if empty
                  item.variants = item.variants || [];

                  const selectedVariantId = selectedVariants[item.id] || null;
                  const selectedVariant =
                    item.variants.length > 0
                      ? item.variants.find((v) => v.id === selectedVariantId)
                      : { id: item.id, name: "Regular", price: item.price };

                  const isInCart = formData.order_items.some(
                    (orderItem) =>
                      orderItem.item_id === item.id &&
                      orderItem.variant_id ===
                        (selectedVariants[item.id] || null)
                  );

                  return (
                    <div key={item.id} className="col-12 col-md-6 col-lg-3">
                      <div
                        className={`card h-100 shadow-sm ${
                          isInCart ? "border-primary" : ""
                        }`}
                      >
                        <div className="position-relative">
                          <img
                            src={
                              item.image ||
                              "https://plus.unsplash.com/premium_photo-1673108852141-e8c3c22a4a22?q=80&w=2940&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" ||
                              "/placeholder.svg" ||
                              "/placeholder.svg"
                            }
                            alt={item.name}
                            className="card-img-top"
                            style={{ height: "130px", objectFit: "cover" }}
                          />
                          {isInCart && (
                            <div className="position-absolute top-0 end-0 bg-primary text-white px-2 py-1 m-2 rounded-pill small">
                              In Cart
                            </div>
                          )}
                        </div>

                        <div className="card-body d-flex flex-column p-3">
                          <h6 className="card-title fw-bold mb-2">
                            {item.name}
                          </h6>

                          {/* Variant Selection */}
                          {item.variants && item.variants.length > 0 && (
                            <div className="mb-3">
                              <select
                                className="form-select form-select-sm"
                                value={selectedVariantId || ""}
                                onChange={(e) =>
                                  handleVariantChange(item.id, e.target.value)
                                }
                              >
                                <option key={""} value={""}>
                                  Select Variant
                                </option>
                                {item.variants.map((variant) => (
                                  <option key={variant?.id} value={variant?.id}>
                                    {variant?.name}
                                    {variant?.size ? ` (${variant?.size})` : ""}
                                    {variant?.flavor
                                      ? ` - ${variant?.flavor}`
                                      : ""}
                                    {" - "}₹
                                    {new Intl.NumberFormat("en-IN", {
                                      style: "currency",
                                      currency: "INR",
                                      minimumFractionDigits: 0,
                                    })
                                      .format(variant?.price)
                                      .replace("₹", "")}
                                  </option>
                                ))}
                              </select>
                            </div>
                          )}

                          <div className="d-flex justify-content-between align-items-center mt-auto">
                            <span className="h6 mb-0 fw-bold text-primary">
                              ₹{item.price}
                            </span>
                            <button
                              className={`btn ${
                                isInCart ? "btn-success" : "btn-dark"
                              } btn-sm px-3`}
                              onClick={() => handleAddItem(item)}
                            >
                              <i
                                className={`fas fa-${
                                  isInCart ? "check" : "plus"
                                } me-1`}
                              ></i>
                              {isInCart ? "Added" : "Add"}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>

        {/* Right Side - Order Form (35%) */}
        <div
          className="col-4"
          style={{ maxWidth: "35%", flex: "0 0 35%", height: "100%" }}
        >
          <div className="h-100 overflow-auto bg-white border-start">
            <div className="p-3">
              {/* Header */}
              <div className="mb-3">
                <div className="d-flex justify-content-between align-items-center">
                  <h4 className="mb-0 fw-bold">
                    {isViewOnly
                      ? "View Order"
                      : id
                      ? "Edit Order"
                      : "Create Order"}
                  </h4>
                  <div className="d-flex gap-4">
                    <div className="d-flex gap-2">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        style={{ maxHeight: "40px" }}
                        onClick={() => {
                          navigate("/restaurant/order");
                        }}
                      >
                        Back
                      </button>
                    </div>
                    {id && hasEditAccess(permissions, "restaurant") ? (
                      <div className="d-flex gap-2">
                        <button
                          type="button"
                          className="btn btn-outline-secondary btn-sm"
                          onClick={() => {
                            const currentPath = isEditable
                              ? location.pathname + "?isViewOnly=true"
                              : location.pathname;
                            navigate(currentPath);
                            setIsEditable((prev) => !prev);
                          }}
                        >
                          {isEditable ? "Cancel Edit" : "Edit"}
                        </button>
                        <button
                          className="btn btn-outline-secondary btn-sm"
                          onClick={handleCancelClick}
                        >
                          Cancel Order
                        </button>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>

              <form onSubmit={handleSubmit}>
                {/* Guest Type and Order Type Selection */}
                <div className="card mb-3">
                  <div className="card-header py-2">
                    <h6 className="card-title mb-0">Order Configuration</h6>
                  </div>
                  <div className="card-body p-3">
                    <div className="row">
                      <div className="col-12 mb-3">
                        <label className="form-label small">Guest Type</label>
                        <div className="d-flex gap-3">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="guestType"
                              id="hotelGuest"
                              checked={formData.guest_type === "hotel_guest"}
                              onChange={() =>
                                handleGuestTypeChange("hotel_guest")
                              }
                              disabled={isViewOnly}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="hotelGuest"
                            >
                              Hotel Guest
                            </label>
                          </div>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="guestType"
                              id="restaurantGuest"
                              checked={
                                formData.guest_type === "restaurant_guest"
                              }
                              onChange={() =>
                                handleGuestTypeChange("restaurant_guest")
                              }
                              disabled={isViewOnly}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="restaurantGuest"
                            >
                              Restaurant Guest
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="col-12">
                        <label className="form-label small">
                          Order Type <span className="text-danger">*</span>
                        </label>
                        {isViewOnly ? (
                          <div className="form-control-plaintext bg-light p-2 rounded small">
                            {formData.order_type === "room_service"
                              ? "Room Service"
                              : formData.order_type === "table_booking"
                              ? "Table Booking"
                              : "Parcel"}
                          </div>
                        ) : (
                          <select
                            className="form-select"
                            value={formData.order_type}
                            onChange={handleOrderTypeChange}
                            required
                          >
                            {formData?.guest_type === "hotel_guest" && (
                              <option value="room_service">Room Service</option>
                            )}
                            <option value="table_booking">Table Booking</option>
                            <option value="parcel">Parcel</option>
                          </select>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Table/Room Information */}
                <div className="card mb-3">
                  <div className="card-header py-2">
                    <h6 className="card-title mb-0">
                      {formData.order_type === "room_service"
                        ? "Room Information"
                        : formData.order_type === "table_booking"
                        ? "Table Information"
                        : "Delivery Information"}
                    </h6>
                  </div>
                  <div className="card-body p-3">
                    <div className="row">
                      {/* {(formData.order_type === "table_booking" || formData.order_type === "room_service" ) && ( */}
                        <>
                          <div className="col-12 mb-2">
                            <FormInput
                              type="datetime-local"
                              label="Date"
                              name="date_time"
                              value={toDateTimeLocal(formData.date_time)}
                              onChange={handleDateChange}
                              required
                              disabled={isViewOnly}
                              restrictPast
                            />
                          </div>
                        { formData.order_type === "table_booking" &&
                          <div className="col-12 mb-3">
                            <label className="form-label small">
                              Table <span className="text-danger">*</span>
                            </label>
                            {isViewOnly ? (
                              <div className="form-control-plaintext bg-light p-2 rounded small">
                                {tables?.find(
                                  (t) => t?.value === formData?.table_id
                                )?.label || "N/A"}
                              </div>
                            ) : (
                              <FormSelect
                                label=""
                                value={formData.table_id}
                                onChange={(e) =>
                                  setFormData((prev) => ({
                                    ...prev,
                                    table_id: e.target.value,
                                  }))
                                }
                                options={tables}
                                required
                              />
                            )}
                          </div>}
                        </>
                      {/* )} */}

                      {((formData.order_type === "room_service" ||
                        formData.guest_type === "hotel_guest") && formData.order_type !== "parcel") && (
                        <div className="col-12 mb-2">
                          <label className="form-label small">
                            Room Number
                            {/* <span className="text-danger">*</span> */}
                          </label>
                          {isViewOnly ? (
                            <div className="form-control-plaintext bg-light p-2 rounded small">
                              {formData.room_number || "Not selected"}
                            </div>
                          ) : (
                            <select
                              className="form-select"
                              value={formData.room_id}
                              onChange={(e) => {
                                setFormData((prev) => ({
                                  ...prev,
                                  room_id: e.target.value,
                                }));
                              }}
                              required
                            >
                              <option value="">Select Room</option>
                              {roomOptions?.map((room) => (
                                <>
                                  <option value={room?.value}>
                                    {room?.label}
                                  </option>
                                </>
                              ))}
                            </select>
                          )}
                        </div>
                      )}

                      {formData.order_type === "parcel" && (
                        <div className="col-12 mb-2">
                          <p className="text-muted small">
                            No table or room selection needed for parcel orders.
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Order Items */}
                <OrderItems
                  orderItems={formData.order_items}
                  setOrderItems={(items) =>
                    setFormData((prev) => ({ ...prev, order_items: items }))
                  }
                  isViewOnly={!isEditable}
                />

                {/* Order Details */}
                <div className="card mb-3">
                  <div className="card-header py-2">
                    <h6 className="card-title mb-0">Order Details</h6>
                  </div>
                  <div className="card-body p-3">
                    <div className="row">
                      <div className="col-6 mb-2">
                        <FormInput
                          label="Service Charge (%)"
                          type="number"
                          step="0.1"
                          min="0"
                          max="100"
                          value={formData.service_charge}
                          readOnly={isViewOnly}
                          disabled={isViewOnly}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              service_charge: e.target.value,
                            }))
                          }
                        />
                      </div>

                      <div className="col-6 mb-2">
                        <FormInput
                          label="Tax (%)"
                          type="number"
                          step="0.1"
                          min="5"
                          max="18"
                          value={formData.tax}
                          readOnly={isViewOnly}
                          disabled={isViewOnly}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              tax: e.target.value,
                            }))
                          }
                        />
                      </div>

                      <div className="col-6 mb-2">
                        <FormInput
                          label="Discount (%)"
                          type="number"
                          step="0.1"
                          min="0"
                          max="100"
                          value={formData.discount}
                          readOnly={isViewOnly}
                          disabled={isViewOnly}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              discount: e.target.value,
                            }))
                          }
                        />
                      </div>

                      <div className="col-6 mb-2">
                        <FormInput
                          label="Tip (₹)"
                          type="number"
                          step="0.01"
                          min="0"
                          value={formData.tip}
                          readOnly={isViewOnly}
                          disabled={isViewOnly}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              tip: e.target.value,
                            }))
                          }
                        />
                      </div>

                      <div className="col-12 mb-2">
                        <FormInput
                          label="Comment"
                          type="textarea"
                          placeholder="Add any special instructions..."
                          value={formData.comment}
                          readOnly={isViewOnly}
                          disabled={isViewOnly}
                          style={{ minHeight: "60px" }}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              comment: e.target.value,
                            }))
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Customer Form */}
                <div className="mb-3">
                  {formData.guests.map((guest, guestIndex) => (
                    <CustomerForm
                      key={guestIndex}
                      guestIndex={guestIndex}
                      guestData={guest}
                      setGuestData={updateGuestData}
                      isViewOnly={!isEditable}
                      onRemoveGuest={
                        formData.guests.length > 1 ? removeGuest : undefined
                      }
                      is_room={is_room}
                      room_id={formData?.room_id}
                    />
                  ))}
                </div>

                {/* Order Summary */}
                <div className="card mb-3">
                  <div className="card-header py-2">
                    <h6 className="card-title mb-0">Order Summary</h6>
                  </div>
                  <div className="card-body p-3">
                    <table className="table table-sm mb-0">
                      <tbody>
                        <tr>
                          <td className="small">Subtotal:</td>
                          <td className="text-end small">
                            ₹
                            {typeof totals?.subtotal === "number"
                              ? totals.subtotal.toFixed(2)
                              : "0.00"}
                          </td>
                        </tr>
                        <tr>
                          <td className="small">
                            Service Charge ({formData.service_charge}%):
                          </td>
                          <td className="text-end small">
                            ₹{totals?.serviceChargeAmount.toFixed(2)}
                          </td>
                        </tr>
                        <tr>
                          <td className="small">Tax ({formData.tax}%):</td>
                          <td className="text-end small">
                            ₹{totals?.taxAmount.toFixed(2)}
                          </td>
                        </tr>
                        <tr>
                          <td className="small">
                            Discount ({formData.discount}%):
                          </td>
                          <td className="text-end small">
                            -₹{totals?.discountAmount?.toFixed(2)}
                          </td>
                        </tr>
                        <tr>
                          <td className="small">Tip:</td>
                          <td className="text-end small">
                            ₹
                            {typeof totals?.tip === "number"
                              ? totals?.tip?.toFixed(2)
                              : "0.00"}
                          </td>
                        </tr>
                        <tr className="table-active">
                          <td className="fw-bold small">Total:</td>
                          <td className="text-end fw-bold">
                            ₹
                            {typeof totals?.total === "number"
                              ? totals?.total?.toFixed(2)
                              : "0.00"}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                {!isViewOnly && (
                  <div className="d-flex justify-content-between gap-2">
                    <div className="d-flex justify-content-end gap-2 mb-3">
                      {id && !isDirty && (
                        <button
                          type="button"
                          className="btn btn-success btn-sm"
                          onClick={handlePayNow}
                          disabled={
                            isLoading || formData.order_items.length === 0
                          }
                        >
                          <i className="bi bi-credit-card me-2"></i>
                          Pay Now
                        </button>
                      )}
                      {id &&
                        !isDirty && formData.room_id &&
                        formData?.guest_type === "hotel_guest" && (
                          <button
                            type="button"
                            className="btn btn-success btn-sm"
                            onClick={handlePayAtCheckout}
                            disabled={
                              isLoading || formData.order_items.length === 0
                            }
                          >
                            <i className="bi bi-credit-card me-2"></i>
                            Pay At Checkout
                          </button>
                        )}
                    </div>
                    <div className="d-flex justify-content-end gap-2 mb-3">
                      <button
                        type="button"
                        className="btn btn-outline-secondary btn-sm"
                        onClick={() => navigate("/restaurant/order")}
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn btn-primary btn-sm"
                        disabled={isLoading || (!isDirty && id)}
                        onClick={handleSubmit}
                      >
                        {isLoading ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            Processing...
                          </>
                        ) : id ? (
                          "Update Order"
                        ) : (
                          "Create Order"
                        )}
                      </button>
                    </div>
                  </div>
                )}
              </form>

              {/* Payment Modal */}
              {showPaymentModal && (
                <div
                  className="modal fade show"
                  style={{
                    display: "block",
                    backgroundColor: "rgba(0,0,0,0.5)",
                  }}
                >
                  <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">
                          <i className="bi bi-credit-card me-2"></i>
                          Complete Payment
                        </h5>
                        <button
                          type="button"
                          className="btn-close"
                          onClick={() => setShowPaymentModal(false)}
                        ></button>
                      </div>
                      <div className="modal-body">
                        {/* Order Summary */}
                        <div className="card mb-4">
                          <div className="card-header">
                            <h6 className="mb-0">Order Summary</h6>
                          </div>
                          <div className="card-body">
                            <table className="table table-sm">
                              <tbody>
                                <tr>
                                  <td>Subtotal:</td>
                                  <td className="text-end">
                                    ₹{totals.subtotal.toFixed(2)}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    Service Charge ({formData.service_charge}%):
                                  </td>
                                  <td className="text-end">
                                    ₹{totals.serviceChargeAmount.toFixed(2)}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Tax ({formData.tax}%):</td>
                                  <td className="text-end">
                                    ₹{totals.taxAmount.toFixed(2)}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Discount ({formData.discount}%):</td>
                                  <td className="text-end">
                                    -₹{totals.discountAmount.toFixed(2)}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Tip:</td>
                                  <td className="text-end">
                                    ₹{totals.tip.toFixed(2)}
                                  </td>
                                </tr>
                                <tr className="table-active">
                                  <td className="fw-bold">Total Amount:</td>
                                  <td className="text-end fw-bold h5">
                                    ₹{totals.total.toFixed(2)}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        {/* Payment Method */}
                        <div className="mb-4">
                          <label className="form-label">Payment Method</label>
                          <div className="row">
                            <div className="col-md-6">
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="paymentMethod"
                                  id="cash"
                                  value="cash"
                                  checked={paymentMethod === "cash"}
                                  onChange={(e) =>
                                    setPaymentMethod(e.target.value)
                                  }
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="cash"
                                >
                                  <i className="bi bi-cash me-2"></i>Cash
                                </label>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="paymentMethod"
                                  id="debit_card"
                                  value="debit_card"
                                  checked={paymentMethod === "debit_card"}
                                  onChange={(e) =>
                                    setPaymentMethod(e.target.value)
                                  }
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="debit_card"
                                >
                                  <i className="bi bi-credit-card me-2"></i>
                                  Debit Card
                                </label>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="paymentMethod"
                                  id="credit_card"
                                  value="credit_card"
                                  checked={paymentMethod === "credit_card"}
                                  onChange={(e) =>
                                    setPaymentMethod(e.target.value)
                                  }
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="credit_card"
                                >
                                  <i className="bi bi-credit-card me-2"></i>
                                  Credit Card
                                </label>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="paymentMethod"
                                  id="upi"
                                  value="upi"
                                  checked={paymentMethod === "upi"}
                                  onChange={(e) =>
                                    setPaymentMethod(e.target.value)
                                  }
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="upi"
                                >
                                  <i className="bi bi-phone me-2"></i>UPI
                                </label>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="paymentMethod"
                                  id="bank_transfer"
                                  value="bank_transfer"
                                  checked={paymentMethod === "bank_transfer"}
                                  onChange={(e) =>
                                    setPaymentMethod(e.target.value)
                                  }
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="bank_transfer"
                                >
                                  <i className="bi bi-globe me-2"></i>Bank
                                  Transfer
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={() => setShowPaymentModal(false)}
                          disabled={isPaymentLoading}
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          className="btn btn-success"
                          onClick={processPayment}
                          disabled={isPaymentLoading}
                        >
                          {isPaymentLoading ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                              ></span>
                              Processing Payment...
                            </>
                          ) : (
                            <>
                              <i className="bi bi-check-circle me-2"></i>
                              Complete Payment (₹{totals.total.toFixed(2)})
                            </>
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <ConfirmationATM
                show={showCancelModal}
                onClose={handleCloseCancelModal}
                onConfirm={handleConfirmCancel}
                title="Confirm Order Cancellation"
                message="Are you sure you want to cancel this order?"
                buttonText="Cancel Order"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateOrder;
